<script setup>
import { ref, onMounted, useTemplateRef, computed } from 'vue';
import { useContentStore } from '../stores/contentStore';
import Image from '../components/Common/Image.vue';
import { gsap } from 'gsap';
import Logo from '../components/Common/Logo.vue';
import { useLocalizationStore } from '../stores/localizationStore';

const contentStore = useContentStore();

const { $trans, $localize } = useLocalizationStore();

const categories = computed(() => {
    return Object.values(contentStore.content.categories).map(category => category.self).sort(function(a, b) {
        if (a.sortkey < b.sortkey) return -1;
        if (a.sortkey > b.sortkey) return 1;
        return 0;
    });
})

const cards = useTemplateRef('cards');

onMounted(() => {
    gsap.from(cards.value.querySelectorAll('.card'), {
        opacity: 0,
        y: 20,
        duration: 1,
        stagger: 0.1,
        ease: "power2.out"
    })
})

</script>

<template>
    <div class="isolate py-16 xl:py-24 4k:py-32 px-10 hd:px-16">
        <div class="flex flex-col items-center mb-16 4k:mb-40">
            <Logo class="mb-16 4k:mb-40" />
            <h1 class="mb-7 hd:mb-10 uppercase text-center r-text-135 font-extra-light" v-text="$trans('categories.title')"></h1>
            <p class="r-text-28 text-center max-w-2xl lg:max-w-3xl xxl:max-w-4xl 4k:max-w-6xl" v-text="$trans('categories.teaser')"></p>
        </div>
        <div class="flex gap-x-10" ref="cards">
            <router-link
                :to="{name: 'category', params: {categoryId: category.id}}"
                v-for="category in categories"
                :key="category.id"
                class="card flex-1 rounded-lg border-gradient shadow-box bg-white/20 hover:bg-secondary/20 transition-colors flex flex-col items-center p-8 pt-12 4k:pt-20 backdrop-blur-2xl"
            >
                <Image class="mb-10 4k:mb-14 h-32 lg:h-36 xl:h-48 4k:h-72" :image="category.image" />
                <h2 class="r-text-28 uppercase text-center" v-text="$localize(category.title)"></h2>
            </router-link>
        </div>
    </div>
</template>
